module.exports = __webpack_public_path__ + "img/品質管理4-2.ae376be1.png";